import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import genderSelectionLoaderJson from '@/data/lottie-animations/genderSelectionLoader.json'

// Статическая замена динамического лендинга `dynamic-loader` для последней живой
// ссылки `?lptype=main_loader&lpid=printable_chair_yoga` (main-yoga). Тексты перенесены
// 1-в-1 из custom-landing.json (lpid.main_loader.printable_chair_yoga) — переводов у них
// не было, во всех локалях отдавались эти же английские строки.
const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Start Your Printable 28-Day Chair Yoga Challenge Today',
			size: 'small',
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: genderSelectionLoaderJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
